import { Injectable } from '@angular/core';
import { find } from 'rxjs/operators';
import { distinct } from 'rxjs/operator/distinct';

@Injectable()
export class DatepickerService {
    datepicker: any;
    init(selectorId: string, config: IDatepickerConfig = {}) {
        var self = this;
        var datepickerConfig = {
            todayHighlight: config.todayHighlight ? config.todayHighlight : true,
            multidate: config.multidate ? config.multidate : true,
            weekStart: config.weekStart ? config.weekStart : Days.Monday,
            clearBtn: config.clearBtn ? config.clearBtn : true,
            todayBtn: config.todayBtn ? config.todayBtn : false,
            calendarWeeks: config.calendarWeeks ? config.calendarWeeks : true,
            updateViewDate: config.updateViewDate ? config.updateViewDate : false,
            templates: {
                leftArrow: '<i class="la la-angle-left"></i>',
                rightArrow: '<i class="la la-angle-right"></i>'
            }
        };
        if (config.datesDisabled)
            datepickerConfig['datesDisabled'] = config.datesDisabled;
        if (config.startDate != null)
            datepickerConfig['startDate'] = config.startDate;
        if (config.format) datepickerConfig['format'] = config.format;
        var datepicker = (<any>$('#' + selectorId)).datepicker(datepickerConfig);
        this.datepicker = datepicker;
        if (config.multiSelectWeek) {
            datepicker.on('changeMonth', function(e) {
                setTimeout(() => {
                    self.MultiSelectWeekButtons(e.target.id);
                    self.MultiSelectDayButtons(e.target.id);
                }, 1);
            });
            datepicker.on('changeYear', function(e) {
                setTimeout(() => {
                    self.MultiSelectWeekButtons(e.target.id);
                }, 1);
            });
            setTimeout(() => {
                this.MultiSelectWeekButtons(selectorId, true);
            }, 1);
        }
        if (config.multiSelectDays) {
            setTimeout(() => {
                this.MultiSelectDayButtons(selectorId, true);
            }, 1);
        }
        return this;
    }
    getDates(selectorId: string) {
        var dates = (<any>$('#' + selectorId)).datepicker('getUTCDates');
        return dates;
    }
    getDate(selectorId: string) {
        var date = (<any>$('#' + selectorId)).datepicker('getUTCDate');
        return date;
    }
    setDates(selectorId: string, dates: Date[]) {
        (<any>$('#' + selectorId)).datepicker('setUTCDates', dates);
    }
    setDate(selectorId: string, date: Date) {
        (<any>$('#' + selectorId)).datepicker('setUTCDate', new Date(date));
    }
    setDatesDisabled(selectorId: string, dates: Date[]) {
        (<any>$('#' + selectorId)).datepicker('setDatesDisabled', dates);
    }
    onChangeDate(this: DatepickerService, callback) {
        var self = this;
        this.datepicker.on('changeDate', function(e) {
            self.MultiSelectWeekButtons(e.target.id);
            callback();
        });
        return this;
    }
    onHide(this: DatepickerService, callback) {
        this.datepicker.on('hide', function() {
            callback(this);
        });
        return this;
    }
    onShow(this: DatepickerService, callback) {
        var self = this;
        this.datepicker.on('show', function(e) {
            self.MultiSelectWeekButtons(e.target.id);
            self.MultiSelectDayButtons(e.target.id, true);
            callback(this);
        });
        return this;
    }
    private MultiSelectDayButtons(selectorId, init = false) {
        var self = this;

        var dateTables = <any>$('.datepicker-days');

        for (let i = 0; i < dateTables.length; i++) {
            var dateTable = dateTables[i];
            (<any>$(dateTable)).find('thead tr:eq(2) .dow').addClass('selectDay');
        }
        if (init) {
            (<any>$('.selectDay')).unbind('click');
            (<any>$('.selectDay')).click(function() {
                var controlDates = 0;
                var index = (<any>$(this)).index();
                var selectedDates = [];
                var trColumns = (<any>$(dateTable)).find('tbody tr');
                for (let k = 0; k < trColumns.length; k++) {
                    var trColumn = trColumns[k];
                    var selectedWeekDay = (<any>$(trColumn)).find('td:eq(' + index + ')');
                    if (!(<any>$(selectedWeekDay)).hasClass('disabled-date')) {
                        var isActive = <any>$(selectedWeekDay).hasClass('active');
                        if (isActive) controlDates = controlDates + 1;
                        var date = (<any>$(selectedWeekDay)).data('date');
                        selectedDates.push(new Date(date));
                    } else {
                        controlDates = controlDates + 1;
                    }
                }
                var currentSelectedDates = self.getDates(selectorId);
                if (controlDates == 6) {
                    var allSelectedDates = currentSelectedDates.filter(function(x) {
                        return (
                            selectedDates
                                .map(y => y.toDateString())
                                .indexOf(x.toDateString()) === -1
                        );
                    });
                } else {
                    var allSelectedDates = currentSelectedDates.concat(selectedDates);
                }
                if (allSelectedDates.length > 0) {
                    let uniqueDates = allSelectedDates
                        .map(s => s.toString())
                        .filter((s, i, a) => a.indexOf(s) == i)
                        .map(s => new Date(s));
                    self.setDates(selectorId, uniqueDates);
                } else {
                    (<any>$('#' + selectorId)).datepicker('clearDates');
                }
            });
        }
    }
    private MultiSelectWeekButtons(selectorId, init = true) {
        var self = this;
        var dateTables = <any>$('.datepicker-days');
        var allSelectedDates = [];

        for (let i = 0; i < dateTables.length; i++) {
            var dateTable = dateTables[i];
            var trRows = (<any>$(dateTable)).find('tbody tr');
            for (let i = 0; i < trRows.length; i++) {
                var row = trRows[i];
                <any>$(row)
                    .find('td:eq(0)')
                    .addClass('selectWeekly');
            }
        }
        if (init) {
            (<any>$('.selectWeekly')).unbind('click');
            (<any>$('.selectWeekly')).click(function() {
                var selectedDates = [];
                var controlDates = 0;
                var selectedWeekDays = (<any>$(this)).parent().find('.day');
                for (let k = 0; k < selectedWeekDays.length; k++) {
                    var weekDay = selectedWeekDays[k];
                    if (!(<any>$(weekDay)).hasClass('disabled-date')) {
                        var isActive = <any>$(weekDay).hasClass('active');
                        if (isActive) controlDates = controlDates + 1;
                        var date = (<any>$(weekDay)).data('date');
                        selectedDates.push(new Date(date));
                    } else {
                        controlDates = controlDates + 1;
                    }
                }
                var currentSelectedDates = self.getDates(selectorId);
                if (controlDates == 7) {
                    allSelectedDates = currentSelectedDates.filter(function(x) {
                        return (
                            selectedDates
                                .map(y => y.toDateString())
                                .indexOf(x.toDateString()) === -1
                        );
                    });
                } else {
                    allSelectedDates = currentSelectedDates.concat(selectedDates);
                }
                if (allSelectedDates.length > 0) {
                    let uniqueDates = allSelectedDates
                        .map(s => s.toString())
                        .filter((s, i, a) => a.indexOf(s) == i)
                        .map(s => new Date(s));
                    self.setDates(selectorId, uniqueDates);
                } else {
                    (<any>$('#' + selectorId)).datepicker('clearDates');
                }
            });
        }
    }
}

export enum DatepickerEvent {
    changeDate = 'changeDate',
    hide = 'hide'
}
export interface IDatepickerConfig {
    todayHighlight?: boolean;
    multidate?: boolean;
    weekStart?: Days;
    clearBtn?: boolean;
    todayBtn?: boolean;
    datesDisabled?: Date[];
    format?: string;
    multiSelectDays?: boolean;
    multiSelectWeek?: boolean;
    calendarWeeks?: boolean;
    updateViewDate?: boolean;
    startDate?: Date;
}
export enum Days {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/datepicker.service.ts